/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzspsychologie14Inputs */

const en__field_enum_mzspsychologie14 = /** @type {(inputs: _Field_Enum_Mzspsychologie14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`psychology and sports science`)
};

const de__field_enum_mzspsychologie14 = /** @type {(inputs: _Field_Enum_Mzspsychologie14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychologie und Sportwissenschaften`)
};

/**
* | output |
* | --- |
* | "psychology and sports science" |
*
* @param {_Field_Enum_Mzspsychologie14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzspsychologie14 = /** @type {((inputs?: _Field_Enum_Mzspsychologie14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzspsychologie14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzspsychologie14(inputs)
	return de__field_enum_mzspsychologie14(inputs)
});
export { _field_enum_mzspsychologie14 as "_field_enum_MZSPSYCHOLOGIE" }